import uly from "ulysses/base";
import ko from "knockout";
import $ from "jquery";

function uniquify_labels(labels) {
    var viewed_labels = {};
    var result = [];
    $.each(labels, function(idx,label) {
        if (viewed_labels[label.id]) {
            viewed_labels[label.id].push(label);
        }
        else
        {
            result.push(label);
            viewed_labels[label.id] = [label];
            label.title = (label.label_type || "") + " " + label.label;
        }

    });
    return result;
}

function get_contextual_collection_type(context) {
    var entity = uly.utils.get_bound_resource(context);
    if (!entity)
        return null;

    var type = ko.unwrap(entity.content_type);
    if (type == "collection" && ko.unwrap(entity.type)) {
        return ko.unwrap(entity.type).toLowerCase();
    }
    return null;
}

function get_contextual_relation(settings, context) {
    var contextual = ko.unwrap(settings.contextual);
    if (!contextual || contextual == "no")
        return null;
    var entity = uly.utils.get_bound_resource(context);
    if (!entity)
        return null;
    if( entity.unique_id ) {
        if (ko.unwrap(entity.unique_id).indexOf("Page#") !== 0)
            return ko.unwrap(entity.unique_id);
    }
    return null;
}

function ensure_settings_complete(origSettings) {
    var settings = ko.unwrap(origSettings);
    var found = false;
    $.each({
        "navigable":true,
        "contextual":true,
        "filter":null,
        "parameter_names": null,
        "parametrised_filters": null,
        "panel_markup": null,
        "display_mode": 'list',
        "search_sort": "-significant_date",
        "use_screen_configuration": null,
        "custom_facets": [],
        "custom_controls": []
    }, function(key, value) {
        if (typeof settings[key] == "undefined") {
            settings[key] = value;
            found = true;
        }
    });
    return [settings, found];
}

export default {
    "uniquify_labels": uniquify_labels,
    "get_contextual_collection_type": get_contextual_collection_type,
    "get_contextual_relation": get_contextual_relation,
    "ensure_settings_complete": ensure_settings_complete
};
